import { mount } from 'svelte';
import App from './App.svelte';
import { loadSettings, applyTheme } from './lib/stores/settings.svelte.ts';
import { loadAppState } from './lib/stores/appState.svelte.ts';
import { loadChildren } from './lib/stores/children.svelte.ts';
import { loadActiveTimer } from './lib/stores/session.svelte.ts';
import { checkAndFireReminders } from './lib/services/reminders.ts';

async function init() {
  applyTheme();

  try {
    await Promise.all([
      loadSettings(),
      loadAppState(),
      loadChildren(),
      loadActiveTimer(),
    ]);
  } catch (e) {
    console.warn('Failed to load saved state, starting fresh:', e);
  }

  mount(App, {
    target: document.getElementById('app')!,
  });

  checkAndFireReminders();
  setInterval(() => checkAndFireReminders(), 60_000);

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') checkAndFireReminders();
  });
  window.addEventListener('focus', () => checkAndFireReminders());
}

init();
